import { registerPlugin } from '@capacitor/core';
const InsightAgeCheck = registerPlugin('InsightAgeCheck', {
    web: () => import('./web').then(m => new m.InsightAgeCheckWeb()),
});
export * from './definitions';
export { InsightAgeCheck };
